function Policies() {
  return (
    <div className="min-h-screen bg-slate-950 py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-white mb-4 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-cyan-400" data-testid="policies-title">
            Policies
          </h1>
          <p className="text-xl text-gray-400">
            Our terms, policies, and commitments to you
          </p>
        </div>
        
        {/* Privacy Policy */}
        <section className="mb-12 bg-slate-800/50 backdrop-blur-sm rounded-2xl p-8 border border-slate-700">
          <h2 className="text-3xl font-bold text-white mb-6 flex items-center">
            <span className="w-10 h-10 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center mr-4">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </span>
            Privacy Policy
          </h2>
          <div className="space-y-4 text-gray-300">
            <p>
              At M31 NanoX, we are committed to protecting your privacy and personal information. This policy outlines how we collect, use, and safeguard your data.
            </p>
            <h3 className="text-xl font-semibold text-white mt-6">Information We Collect</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Contact information (name, email, phone number)</li>
              <li>Company details and business requirements</li>
              <li>Technical specifications and order history</li>
              <li>Website usage data and analytics</li>
            </ul>
            <h3 className="text-xl font-semibold text-white mt-6">How We Use Your Information</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>To process orders and fulfill your requests</li>
              <li>To provide technical support and customer service</li>
              <li>To improve our products and services</li>
              <li>To send relevant product updates and communications</li>
            </ul>
            <p className="mt-4">
              We never sell or share your personal information with third parties without your explicit consent.
            </p>
          </div>
        </section>
        
        {/* Terms of Service */}
        <section className="mb-12 bg-slate-800/50 backdrop-blur-sm rounded-2xl p-8 border border-slate-700">
          <h2 className="text-3xl font-bold text-white mb-6 flex items-center">
            <span className="w-10 h-10 bg-gradient-to-br from-cyan-500 to-blue-500 rounded-lg flex items-center justify-center mr-4">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </span>
            Terms of Service
          </h2>
          <div className="space-y-4 text-gray-300">
            <p>
              By accessing and using M31 NanoX services, you agree to be bound by these terms and conditions.
            </p>
            <h3 className="text-xl font-semibold text-white mt-6">Product Usage</h3>
            <p>
              All materials sold by M31 NanoX are intended for professional research, development, and manufacturing purposes. Customers are responsible for ensuring proper handling, storage, and disposal of materials according to applicable safety regulations.
            </p>
            <h3 className="text-xl font-semibold text-white mt-6">Intellectual Property</h3>
            <p>
              All content, trademarks, and intellectual property on this website are owned by M31 NanoX. Unauthorized use or reproduction is strictly prohibited.
            </p>
            <h3 className="text-xl font-semibold text-white mt-6">Liability</h3>
            <p>
              While we strive for accuracy, M31 NanoX is not liable for indirect, incidental, or consequential damages arising from the use of our products or services.
            </p>
          </div>
        </section>
        
        {/* Shipping Policy */}
        <section className="mb-12 bg-slate-800/50 backdrop-blur-sm rounded-2xl p-8 border border-slate-700">
          <h2 className="text-3xl font-bold text-white mb-6 flex items-center">
            <span className="w-10 h-10 bg-gradient-to-br from-cyan-500 to-blue-500 rounded-lg flex items-center justify-center mr-4">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
              </svg>
            </span>
            Shipping & Handling
          </h2>
          <div className="space-y-4 text-gray-300">
            <h3 className="text-xl font-semibold text-white">Shipping Methods</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Standard shipping: 5-7 business days</li>
              <li>Express shipping: 2-3 business days</li>
              <li>International shipping: 7-14 business days</li>
              <li>Custom arrangements available for bulk orders</li>
            </ul>
            <h3 className="text-xl font-semibold text-white mt-6">Special Handling</h3>
            <p>
              Many of our materials require special packaging and handling due to their reactive or sensitive nature. All shipments comply with international hazardous materials regulations and include appropriate safety documentation.
            </p>
            <h3 className="text-xl font-semibold text-white mt-6">Tracking & Insurance</h3>
            <p>
              All orders include tracking information and are fully insured. You will receive tracking details via email once your order ships.
            </p>
          </div>
        </section>
        
        {/* Return Policy */}
        <section className="mb-12 bg-slate-800/50 backdrop-blur-sm rounded-2xl p-8 border border-slate-700">
          <h2 className="text-3xl font-bold text-white mb-6 flex items-center">
            <span className="w-10 h-10 bg-gradient-to-br from-green-500 to-emerald-500 rounded-lg flex items-center justify-center mr-4">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
            </span>
            Return & Refund Policy
          </h2>
          <div className="space-y-4 text-gray-300">
            <p>
              We stand behind the quality of our products. If you are not satisfied with your purchase, please review our return policy.
            </p>
            <h3 className="text-xl font-semibold text-white mt-6">Returns</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Returns must be requested within 30 days of delivery</li>
              <li>Products must be unopened and in original packaging</li>
              <li>Custom or special-order items are non-returnable</li>
              <li>Contact our support team to initiate a return</li>
            </ul>
            <h3 className="text-xl font-semibold text-white mt-6">Refunds</h3>
            <p>
              Approved returns will be refunded to the original payment method within 10 business days of receiving the returned product. Shipping costs are non-refundable unless the return is due to our error.
            </p>
            <h3 className="text-xl font-semibold text-white mt-6">Defective Products</h3>
            <p>
              If you receive a defective or damaged product, please contact us immediately with photos. We will arrange for replacement or full refund at no cost to you.
            </p>
          </div>
        </section>
        
        {/* Contact */}
        <div className="text-center bg-gradient-to-r from-blue-900/20 via-cyan-900/20 to-blue-900/20 rounded-2xl p-8 border border-cyan-500/20">
          <h3 className="text-2xl font-bold text-white mb-4">Questions About Our Policies?</h3>
          <p className="text-gray-300 mb-6">
            If you have any questions or concerns about our policies, please don't hesitate to reach out.
          </p>
          <a
            href="/contact"
            data-testid="contact-from-policies-button"
            className="inline-block px-8 py-4 bg-gradient-to-r from-blue-500 to-cyan-500 text-white font-semibold rounded-xl hover:shadow-lg hover:shadow-cyan-500/50 transition-all transform hover:scale-105"
          >
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
}

export default Policies;